import * as React from 'react';
import './App.css';
import {Home} from "./components/home/Home";
import {About} from "./components/about/About";
import {Route, Routes} from "react-router";
import {Contact} from "./components/contact/Contact";
import {Menu} from "./components/menu/Menu";
import {BakeryCalendar} from "./components/calendar/BakeryCalendar";
import {DropInfo} from "./components/drops/DropInfo";

function AppRoutes(props) {

  return (
      <Routes>
        <Route path={'/'} element={<Home/>} />
        <Route path={'/drops'} element={<DropInfo/>} />
        <Route path={'/calendar'} element={<BakeryCalendar/>} />
        <Route path={'/about'} element={<About/>} />
        <Route path={'/menu'} element={<Menu/>} />
        <Route path={'/contact'} element={<Contact/>} />
      </Routes>
  );
}

export default AppRoutes;
